import { getCurrentUser } from 'aws-amplify/auth';
import 'aws-amplify/auth/enable-oauth-listener';
import { Hub } from 'aws-amplify/utils';
import React from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import '../../assets/stylesheets/components/login.scss';

import { APP_ROUTES } from '../../constants';
import { useLocalStorage } from '../../hooks';
import { Alert, LoadingOverlay } from '../atoms';

export const OauthIDPResponse = () => {
  const history = useHistory();
  const [, setUserIsLogged] = useLocalStorage('userLogged', false);

  Hub.listen('auth', async ({ payload }) => {
    switch (payload.event) {
      case 'signedIn':
      case 'customOAuthState':
      case 'signInWithRedirect':
        await getCurrentUser();
        // Flip userLogged before navigating so AppContainer renders the loading
        // overlay (userIsLogged && !hasFleetData) instead of momentarily showing
        // the Login page while the session check is still in flight.
        setUserIsLogged(true);
        history.push(APP_ROUTES.default);
        break;
      case 'signInWithRedirect_failure':
        console.error('Sign in with redirect failed', payload);
        await new Alert(JSON.stringify(payload)).promise;
        history.push(APP_ROUTES.login);
        break;
      default:
        break;
    }
  });

  return <LoadingOverlay />;
};

export default withRouter(OauthIDPResponse);
